import { render, staticRenderFns } from "./DeviceFilterBadge.vue?vue&type=template&id=52d56879&scoped=true"
import script from "./DeviceFilterBadge.vue?vue&type=script&lang=js"
export * from "./DeviceFilterBadge.vue?vue&type=script&lang=js"
import style0 from "./DeviceFilterBadge.vue?vue&type=style&index=0&id=52d56879&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d56879",
  null
  
)

export default component.exports